
import React from 'react';

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}

const Logo: React.FC<LogoProps> = ({ className = "h-12", variant = 'full' }) => {
  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <svg viewBox="-50 0 560 380" preserveAspectRatio="xMidYMid meet" className="h-full w-auto" xmlns="http://www.w3.org/2000/svg">
        {/* Sun Rays */}
        <g fill="#f48221">
          <path d="M230 10 L240 50 L220 50 Z" /> {/* Top ray */}
          <path d="M280 25 L275 65 L255 55 Z" />
          <path d="M320 60 L305 90 L285 75 Z" />
          <path d="M345 110 L315 125 L305 105 Z" />
          <path d="M355 160 L315 160 L315 145 Z" />
          
          <path d="M180 25 L185 65 L205 55 Z" />
          <path d="M140 60 L155 90 L175 75 Z" />
          <path d="M115 110 L145 125 L155 105 Z" />
          <path d="M105 160 L145 160 L145 145 Z" />
        </g>
        
        {/* Half Sun */}
        <path d="M150 160 A80 80 0 0 1 310 160" fill="#f48221" />
        
        {/* SGES Text Styled */}
        <g fill="#3b6b4c">
          <path d="M90 180 H170 V205 H115 V215 H170 V240 H90 V180 Z" /> {/* S */}
          <path d="M180 180 H260 V205 H205 V215 H240 V225 H205 V230 H260 V240 H180 V180 Z" /> {/* G */}
          <path d="M270 180 H350 V205 H295 V215 H340 V225 H295 V230 H350 V240 H270 V180 Z" /> {/* E */}
          <path d="M360 180 H430 V205 H385 V215 H430 V240 H360 V180 Z" /> {/* S */}
        </g>
        
        {/* Lightning Bolt */}
        <path d="M220 190 L240 210 L225 210 L240 230" fill="#f48221" stroke="#f48221" strokeWidth="2" strokeLinecap="round" />

        {variant === 'full' && (
          <>
            {/* SURYAMITRA Box */}
            <rect x="90" y="250" width="340" height="40" fill="#f48221" />
            <text x="260" y="280" fontFamily="serif" fontSize="28" fontWeight="bold" fill="white" textAnchor="middle" letterSpacing="2">SURYAMITRA</text>
            
            {/* GREEN ENERGY SYSTEMS */}
            <text x="260" y="310" fontFamily="serif" fontSize="16" fontWeight="bold" fill="#3b6b4c" textAnchor="middle" letterSpacing="1">GREEN ENERGY SYSTEMS</text>
          </>
        )}
      </svg>
    </div>
  );
};

export default Logo;
